(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("AdminViewOnlineLessonModalCtrl", ["$rootScope", "$scope", "$uibModalInstance", "$location", "$translate", "learningItemOnlineLesson", "scormService", adminViewOnlineLessonModalCtrl]);
    function adminViewOnlineLessonModalCtrl($rootScope, $scope, $uibModalInstance, $location, $translate, learningItemOnlineLesson, scormService) {
        var vm = this;
        vm.learningItemOnlineLesson = learningItemOnlineLesson;
        if ($location.protocol() === "http") {
            vm.learningItemOnlineLesson.launchFileUrl = vm.learningItemOnlineLesson.launchFileUrl.replace("https", "http");
        }
        if (vm.learningItemOnlineLesson.onlineLessonTypeId === 1)
            scormService.init(vm.learningItemOnlineLesson, true);
        else {
            var endpointUrl;
            if ($location.port() !== 80)
                endpointUrl = $location.protocol() + "://" + $location.host() + ":" + $location.port() + "/api/adminOnlineLesson/";
            else
                endpointUrl = $location.protocol() + "://" + $location.host() + "/api/adminOnlineLesson/";
            var actor = {
                objectType: "Agent",
                name: "Admin"
            };
            vm.learningItemOnlineLesson.launchFileUrl += "?endpoint=" + endpointUrl + "&actor=" + JSON.stringify(actor);
        }
        vm.close = function () {
            $uibModalInstance.close();
        };
        this.$onDestroy = function () {
            //Clear Lectora session storage
            var removeArray = [];
            for (var i = 0; i < sessionStorage.length; i++) {
                if (sessionStorage.key(i).startsWith("Lectora")) {
                    removeArray.push(sessionStorage.key(i));
                }
            }
            for (var key in removeArray) {
                if (removeArray.hasOwnProperty(key)) {
                    sessionStorage.removeItem(removeArray[key]);
                }
            }
        };
        $rootScope.$on("onlineLessonTerminated", function () {
            vm.close();
        });
    }
}());
